//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DateResources',
  props: {
    total_projects_dev: {
      type: Number,
      required: true
    },
    total_projects_prod: {
      type: Number,
      required: true
    },
    total_projects_prod_limit: {
      type: Number,
      required: true
    },
    total_messages: {
      type: Number,
      required: true
    },
    total_sessions: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      titleClass: {
        'pb-0': this.$vuetify.breakpoint.mdAndUp,
        'pb-0 pr-0': this.$vuetify.breakpoint.smAndDown
      },
      iconStyle: {
        backgroundColor: 'blue',
        padding: '7px',
        borderRadius: '20%',
        fontSize: '24px'
      },
      textClass: {
        'text-center': true,
        'd-flex': true,
        'align-center': true,
        'justify-center': true
      }
    };
  }
};